export const minMobileScreenWidth = 425
export const maxMobileScreenWidth = 1023

export const minTabletScreenWidth = 768
export const maxTabletScreenWidth = 1023

export const minDesktopScreenWidth = 1024
export const maxDesktopScreenWidth = 1920
